import { render } from "./CountryPage.vue?vue&type=template&id=49353228&ts=true"
import script from "./CountryPage.vue?vue&type=script&lang=ts"
export * from "./CountryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__